{
  "version": "2026-04-11",
  "figures": {
    "mir_standard": {
      "value": 29000,
      "register_row": "§4 Minimum income requirement",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.3.1 · E-LTRP.3.1",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null
    },
    "mir_transitional": {
      "value": 18600,
      "register_row": "§4 Transitional threshold",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-LTRP.3.7",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null
    },
    "transitional_cutoff": {
      "value": "2024-04-11",
      "register_row": "§4 Transitional threshold",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-LTRP.3.7",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null
    },
    "savings_floor": {
      "value": 16000,
      "register_row": "§4 Cash savings floor",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.3.1(b)(ii) · E-LTRP.3.1(b)(ii)",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null
    },
    "savings_multiplier_ec_ltr": {
      "value": 2.5,
      "register_row": "§4 Savings multiplier — EC and LTR",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.3.1(b)(ii) · E-LTRP.3.1(b)(ii)",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null
    },
    "savings_multiplier_ilr": {
      "value": 1,
      "register_row": "§4 Savings multiplier — ILR",
      "citation": {
        "instrument": "Guidance",
        "paragraph": "Appendix FM Section 1.7 — cash savings at the indefinite leave to remain stage: the whole of the amount above £16,000 can be added to income",
        "guidance_version": "published 11 November 2025",
        "published": "2025-11-11",
        "url": "https://assets.publishing.service.gov.uk/media/691209e3e9348ac8fb54f4ba/Family+Migration+Appendix+FM+Section+and+Appendix+HM+Armed+Forces+Financial+Requirement.pdf"
      },
      "effective_from": "2025-11-11",
      "effective_to": null
    },
    "savings_holding_months": {
      "value": 6,
      "register_row": "§4 Savings holding period",
      "citation": {
        "instrument": "Appendix FM-SE",
        "paragraph": "cash savings — held by the applicant, their partner or both jointly, and under their control, for at least 6 months prior to the date of application",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-se-family-members-specified-evidence"
      },
      "effective_from": "2024-04-11",
      "effective_to": null
    },
    "cat_a_tenure_months": {
      "value": 6,
      "register_row": "§4 Category A minimum tenure",
      "citation": {
        "instrument": "Guidance",
        "paragraph": "Appendix FM 1.7 — Category A: with current employer for 6 months or more",
        "guidance_version": "published 11 November 2025",
        "published": "2025-11-11",
        "url": "https://assets.publishing.service.gov.uk/media/691209e3e9348ac8fb54f4ba/Family+Migration+Appendix+FM+Section+and+Appendix+HM+Armed+Forces+Financial+Requirement.pdf"
      },
      "effective_from": "2025-11-11",
      "effective_to": null
    },
    "cat_b_period_months": {
      "value": 12,
      "register_row": "§4 Category B assessment period",
      "citation": {
        "instrument": "Guidance",
        "paragraph": "Appendix FM 1.7 — Category B part (2): actual income received in the 12 months prior to the date of application",
        "guidance_version": "published 11 November 2025",
        "published": "2025-11-11",
        "url": "https://assets.publishing.service.gov.uk/media/691209e3e9348ac8fb54f4ba/Family+Migration+Appendix+FM+Section+and+Appendix+HM+Armed+Forces+Financial+Requirement.pdf"
      },
      "effective_from": "2025-11-11",
      "effective_to": null
    },
    "evidence_window_days": {
      "value": 28,
      "register_row": "§4 Evidence dating window",
      "citation": {
        "instrument": "Appendix FM-SE",
        "paragraph": "evidence for a period ending with the date of application must be dated no earlier than 28 days before the date of application",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-se-family-members-specified-evidence"
      },
      "effective_from": "2024-04-11",
      "effective_to": null
    },
    "cohabitation_years_unmarried": {
      "value": 2,
      "register_row": "§4 (relationship) — unmarried partners",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "GEN.1.2(iv) — living together in a relationship akin to marriage or civil partnership for at least two years",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null
    },
    "minimum_age": {
      "value": 18,
      "register_row": "§4 (relationship) — both parties aged 18 or over",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.2.2 · E-LTRP.1.4",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null
    },
    "english_level_ec": {
      "value": "A1",
      "register_row": "§5 Entry clearance",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.4.1 — English language at level A1 (speaking and listening)",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null
    },
    "english_level_ltr": {
      "value": "A2",
      "register_row": "§5 First extension, FLR(M)",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-LTRP.4.1 — English language at level A2 (speaking and listening) at the first extension",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null
    },
    "english_level_ilr": {
      "value": "B1",
      "register_row": "§5 Settlement / ILR",
      "citation": {
        "instrument": "Appendix KoLL",
        "paragraph": "Appendix KoLL — English language at level B1 for settlement",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-koll"
      },
      "effective_from": "2024-04-11",
      "effective_to": null
    },
    "english_level_ilr_from_2027": {
      "value": "B2",
      "register_row": "§5 Settlement / ILR — rising to B2 on 26 March 2027",
      "citation": {
        "instrument": "Appendix KoLL",
        "paragraph": "Appendix KoLL as amended by HC 1691 — level B2 for settlement from 26 March 2027",
        "published": "2026-03-05",
        "url": "https://www.gov.uk/government/collections/immigration-rules-statement-of-changes"
      },
      "effective_from": "2027-03-26",
      "effective_to": null
    },
    "english_b2_from": {
      "value": "2027-03-26",
      "register_row": "§5 Settlement / ILR — rising to B2 on 26 March 2027",
      "citation": {
        "instrument": "Appendix KoLL",
        "paragraph": "HC 1691, 5 March 2026 — B2 applies to applications on or after 26 March 2027",
        "published": "2026-03-05",
        "url": "https://www.gov.uk/government/collections/immigration-rules-statement-of-changes"
      },
      "effective_from": "2024-04-11",
      "effective_to": null
    },
    "payslip_window_days": {
      "value": 28,
      "register_row": "§4 Evidence dating window",
      "citation": {
        "instrument": "Appendix FM-SE",
        "paragraph": "payslips and bank statements must be dated no earlier than 28 days before the date of application",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-se-family-members-specified-evidence"
      },
      "effective_from": "2024-04-11",
      "effective_to": null
    }
  },
  "rules": [
    {
      "id": "FIN.THRESHOLD",
      "title": "Minimum income requirement — which figure applies",
      "plain_english": "The financial requirement is assessed against a minimum income figure. Applications are assessed against £29,000. A lower figure of £18,600 applies only where all of the following hold: the first application as a partner or fiancé(e) was made before 11 April 2024, that application led to a grant of permission, the applicant still holds permission on the five-year partner route, and this application is to stay with the same partner. The lower figure is never available at entry clearance.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.3.1 · E-LTRP.3.1 · E-LTRP.3.7",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "select_mir_threshold",
      "evidence": [],
      "depends_on": [],
      "params": {
        "standard_figure": "mir_standard",
        "transitional_figure": "mir_transitional",
        "cutoff_figure": "transitional_cutoff"
      }
    },
    {
      "id": "FIN.CATEGORY",
      "title": "Which income category applies",
      "plain_english": "Income is assessed under a named category. Category A is salaried employment with the same employer for 6 months or more. Category B is salaried employment of less than 6 months with the current employer. Category D is cash savings. Savings can be combined with Category A income, and with the current-salary part of Category B, but never with self-employment income.",
      "citation": {
        "instrument": "Guidance",
        "paragraph": "Appendix FM 1.7 — income categories A to G",
        "guidance_version": "published 11 November 2025",
        "published": "2025-11-11",
        "url": "https://assets.publishing.service.gov.uk/media/691209e3e9348ac8fb54f4ba/Family+Migration+Appendix+FM+Section+and+Appendix+HM+Armed+Forces+Financial+Requirement.pdf"
      },
      "effective_from": "2025-11-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "select_financial_category",
      "evidence": [],
      "depends_on": [],
      "params": {
        "tenure_months_figure": "cat_a_tenure_months"
      }
    },
    {
      "id": "FIN.INCOME.CAT-A",
      "title": "Category A — salaried income, 6 months or more with the same employer",
      "plain_english": "Under Category A, the sponsor's gross annual salary at the date of application must be at or above the applicable minimum income figure, evidenced by 6 months of payslips, the bank statements showing each salary payment arriving, and a letter from the employer confirming the employment.",
      "citation": {
        "instrument": "Guidance",
        "paragraph": "Appendix FM 1.7 — Category A: with current employer for 6 months or more, salaried employment",
        "guidance_version": "published 11 November 2025",
        "published": "2025-11-11",
        "url": "https://assets.publishing.service.gov.uk/media/691209e3e9348ac8fb54f4ba/Family+Migration+Appendix+FM+Section+and+Appendix+HM+Armed+Forces+Financial+Requirement.pdf"
      },
      "effective_from": "2025-11-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": "employment_category_a",
      "evaluate": "cat_a_salaried_income",
      "evidence": [
        {
          "id": "payslips-6-months",
          "label": "Payslips covering the 6 months before the date of application",
          "holder": "sponsor",
          "count": {
            "min": 6,
            "period": "month"
          },
          "freshness": {
            "window_days": 28,
            "relative_to": "date_of_application",
            "action_on_stale": "recollect"
          }
        },
        {
          "id": "bank-statements-6-months",
          "label": "Bank statements showing each of those salary payments arriving",
          "holder": "sponsor",
          "count": {
            "min": 6,
            "period": "month"
          },
          "freshness": {
            "window_days": 28,
            "relative_to": "date_of_application",
            "action_on_stale": "recollect"
          },
          "format_rules": [
            "Statements on bank stationery, or electronic statements with a supporting letter or stamp from the bank"
          ]
        },
        {
          "id": "employer-letter",
          "label": "A letter from the employer confirming the employment, the salary, and how long it has been held",
          "holder": "sponsor",
          "count": {
            "min": 1
          },
          "freshness": {
            "window_days": 28,
            "relative_to": "date_of_application",
            "action_on_stale": "redate"
          }
        }
      ],
      "depends_on": [
        "FIN.THRESHOLD",
        "FIN.CATEGORY"
      ],
      "params": {}
    },
    {
      "id": "FIN.INCOME.CAT-B",
      "title": "Category B — less than 6 months with the current employer",
      "plain_english": "Under Category B, two things must both be shown: a current gross annual salary at or above the applicable minimum income figure, and actual income received in the 12 months before the application at or above the same figure.",
      "citation": {
        "instrument": "Guidance",
        "paragraph": "Appendix FM 1.7 — Category B: less than 6 months with current employer or variable income",
        "guidance_version": "published 11 November 2025",
        "published": "2025-11-11",
        "url": "https://assets.publishing.service.gov.uk/media/691209e3e9348ac8fb54f4ba/Family+Migration+Appendix+FM+Section+and+Appendix+HM+Armed+Forces+Financial+Requirement.pdf"
      },
      "effective_from": "2025-11-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": "employment_category_b",
      "evaluate": "cat_b_route",
      "evidence": [
        {
          "id": "payslips-12-months",
          "label": "Payslips covering the 12 months before the date of application, from all employment in that period",
          "holder": "sponsor",
          "count": {
            "min": 12,
            "period": "month"
          }
        },
        {
          "id": "bank-statements-12-months",
          "label": "Bank statements showing each of those payments arriving",
          "holder": "sponsor",
          "count": {
            "min": 12,
            "period": "month"
          },
          "format_rules": [
            "Statements on bank stationery, or electronic statements with a supporting letter or stamp from the bank"
          ]
        },
        {
          "id": "employer-letter",
          "label": "A letter from the current employer confirming the employment and the salary",
          "holder": "sponsor",
          "count": {
            "min": 1
          },
          "freshness": {
            "window_days": 28,
            "relative_to": "date_of_application",
            "action_on_stale": "redate"
          }
        }
      ],
      "depends_on": [
        "FIN.THRESHOLD",
        "FIN.CATEGORY"
      ],
      "params": {
        "tenure_months_figure": "cat_a_tenure_months"
      }
    },
    {
      "id": "FIN.SAVINGS.EC-LTR",
      "title": "Cash savings — entry clearance and extension",
      "plain_english": "Where cash savings are relied on at entry clearance or extension, the rules ask for savings of £16,000 plus 2.5 times the amount by which gross annual income falls short of the minimum income requirement. The savings must have been held by the applicant, their partner, or both jointly for at least 6 months before the date of application, and be under their control.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.3.1(b)(ii) · E-LTRP.3.1(b)(ii)",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR"
      ],
      "applies_when": "savings_only_route",
      "evaluate": "cash_savings_sufficiency",
      "evidence": [
        {
          "id": "savings-account-statements",
          "label": "Statements for the account holding the savings, covering the full 6-month holding period",
          "holder": "either",
          "count": {
            "min": 6,
            "period": "month"
          },
          "format_rules": [
            "Statements on bank or building society stationery, or electronic statements with a supporting letter or stamp from the bank"
          ]
        }
      ],
      "depends_on": [
        "FIN.THRESHOLD"
      ],
      "params": {
        "floor_figure": "savings_floor",
        "multiplier_figure": "savings_multiplier_ec_ltr",
        "holding_months_figure": "savings_holding_months"
      }
    },
    {
      "id": "FIN.SAVINGS.ILR",
      "title": "Cash savings — settlement",
      "plain_english": "Where cash savings are relied on at settlement, the rules ask for savings of £16,000 plus the full amount by which gross annual income falls short of the minimum income requirement — the 2.5 multiplier used at earlier stages does not apply at settlement. The savings must have been held by the applicant, their partner, or both jointly for at least 6 months before the date of application, and be under their control.",
      "citation": {
        "instrument": "Guidance",
        "paragraph": "Appendix FM Section 1.7 — cash savings at the indefinite leave to remain stage",
        "guidance_version": "published 11 November 2025",
        "published": "2025-11-11",
        "url": "https://assets.publishing.service.gov.uk/media/691209e3e9348ac8fb54f4ba/Family+Migration+Appendix+FM+Section+and+Appendix+HM+Armed+Forces+Financial+Requirement.pdf"
      },
      "effective_from": "2025-11-11",
      "effective_to": null,
      "stages": [
        "ILR"
      ],
      "applies_when": "savings_only_route",
      "evaluate": "cash_savings_sufficiency",
      "evidence": [
        {
          "id": "savings-account-statements",
          "label": "Statements for the account holding the savings, covering the full 6-month holding period",
          "holder": "either",
          "count": {
            "min": 6,
            "period": "month"
          },
          "format_rules": [
            "Statements on bank or building society stationery, or electronic statements with a supporting letter or stamp from the bank"
          ]
        }
      ],
      "depends_on": [
        "FIN.THRESHOLD"
      ],
      "params": {
        "floor_figure": "savings_floor",
        "multiplier_figure": "savings_multiplier_ilr",
        "holding_months_figure": "savings_holding_months"
      }
    },
    {
      "id": "FIN.COMBINE.EC-LTR",
      "title": "Combining employment income with cash savings — entry clearance and extension",
      "plain_english": "Where salaried income under Category A falls short of the applicable minimum income figure, cash savings can cover the difference: £16,000 plus the stage multiplier applied to the shortfall, held for at least 6 months. Savings can never be combined with Category B's 12-month income history or with self-employment income.",
      "citation": {
        "instrument": "Guidance",
        "paragraph": "Appendix FM 1.7 — Category A income can be combined with Category D cash savings; savings can never be combined with Category B part (2) or with Categories F and G",
        "guidance_version": "published 11 November 2025",
        "published": "2025-11-11",
        "url": "https://assets.publishing.service.gov.uk/media/691209e3e9348ac8fb54f4ba/Family+Migration+Appendix+FM+Section+and+Appendix+HM+Armed+Forces+Financial+Requirement.pdf"
      },
      "effective_from": "2025-11-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR"
      ],
      "applies_when": "combination_route",
      "evaluate": "combine_income_savings",
      "evidence": [
        {
          "id": "payslips-6-months",
          "label": "Payslips covering the 6 months before the date of application",
          "holder": "sponsor",
          "count": {
            "min": 6,
            "period": "month"
          },
          "freshness": {
            "window_days": 28,
            "relative_to": "date_of_application",
            "action_on_stale": "recollect"
          }
        },
        {
          "id": "bank-statements-6-months",
          "label": "Bank statements showing each of those salary payments arriving",
          "holder": "sponsor",
          "count": {
            "min": 6,
            "period": "month"
          },
          "freshness": {
            "window_days": 28,
            "relative_to": "date_of_application",
            "action_on_stale": "recollect"
          },
          "format_rules": [
            "Statements on bank stationery, or electronic statements with a supporting letter or stamp from the bank"
          ]
        },
        {
          "id": "employer-letter",
          "label": "A letter from the employer confirming the employment, the salary, and how long it has been held",
          "holder": "sponsor",
          "count": {
            "min": 1
          },
          "freshness": {
            "window_days": 28,
            "relative_to": "date_of_application",
            "action_on_stale": "redate"
          }
        },
        {
          "id": "savings-account-statements",
          "label": "Statements for the account holding the savings, covering the full 6-month holding period",
          "holder": "either",
          "count": {
            "min": 6,
            "period": "month"
          },
          "format_rules": [
            "Statements on bank or building society stationery, or electronic statements with a supporting letter or stamp from the bank"
          ]
        }
      ],
      "depends_on": [
        "FIN.THRESHOLD",
        "FIN.CATEGORY"
      ],
      "params": {
        "floor_figure": "savings_floor",
        "multiplier_figure": "savings_multiplier_ec_ltr",
        "holding_months_figure": "savings_holding_months",
        "tenure_months_figure": "cat_a_tenure_months"
      }
    },
    {
      "id": "FIN.COMBINE.ILR",
      "title": "Combining employment income with cash savings — settlement",
      "plain_english": "Where salaried income under Category A falls short of the applicable minimum income figure, cash savings can cover the difference: £16,000 plus the stage multiplier applied to the shortfall, held for at least 6 months. Savings can never be combined with Category B's 12-month income history or with self-employment income.",
      "citation": {
        "instrument": "Guidance",
        "paragraph": "Appendix FM 1.7 — Category A income can be combined with Category D cash savings; savings can never be combined with Category B part (2) or with Categories F and G",
        "guidance_version": "published 11 November 2025",
        "published": "2025-11-11",
        "url": "https://assets.publishing.service.gov.uk/media/691209e3e9348ac8fb54f4ba/Family+Migration+Appendix+FM+Section+and+Appendix+HM+Armed+Forces+Financial+Requirement.pdf"
      },
      "effective_from": "2025-11-11",
      "effective_to": null,
      "stages": [
        "ILR"
      ],
      "applies_when": "combination_route",
      "evaluate": "combine_income_savings",
      "evidence": [
        {
          "id": "payslips-6-months",
          "label": "Payslips covering the 6 months before the date of application",
          "holder": "sponsor",
          "count": {
            "min": 6,
            "period": "month"
          },
          "freshness": {
            "window_days": 28,
            "relative_to": "date_of_application",
            "action_on_stale": "recollect"
          }
        },
        {
          "id": "bank-statements-6-months",
          "label": "Bank statements showing each of those salary payments arriving",
          "holder": "sponsor",
          "count": {
            "min": 6,
            "period": "month"
          },
          "freshness": {
            "window_days": 28,
            "relative_to": "date_of_application",
            "action_on_stale": "recollect"
          },
          "format_rules": [
            "Statements on bank stationery, or electronic statements with a supporting letter or stamp from the bank"
          ]
        },
        {
          "id": "employer-letter",
          "label": "A letter from the employer confirming the employment, the salary, and how long it has been held",
          "holder": "sponsor",
          "count": {
            "min": 1
          },
          "freshness": {
            "window_days": 28,
            "relative_to": "date_of_application",
            "action_on_stale": "redate"
          }
        },
        {
          "id": "savings-account-statements",
          "label": "Statements for the account holding the savings, covering the full 6-month holding period",
          "holder": "either",
          "count": {
            "min": 6,
            "period": "month"
          },
          "format_rules": [
            "Statements on bank or building society stationery, or electronic statements with a supporting letter or stamp from the bank"
          ]
        }
      ],
      "depends_on": [
        "FIN.THRESHOLD",
        "FIN.CATEGORY"
      ],
      "params": {
        "floor_figure": "savings_floor",
        "multiplier_figure": "savings_multiplier_ilr",
        "holding_months_figure": "savings_holding_months",
        "tenure_months_figure": "cat_a_tenure_months"
      }
    },
    {
      "id": "REL.MARRIAGE",
      "title": "A valid marriage or civil partnership",
      "plain_english": "Where the relationship is a marriage or civil partnership, the rules ask for evidence of it. For unmarried partners the two-year living-together requirement applies instead.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.2.7 · GEN.1.2",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "married_or_civil_partners",
      "evidence": [
        {
          "id": "marriage-certificate",
          "label": "The marriage or civil partnership certificate",
          "holder": "joint",
          "count": {
            "min": 1
          }
        }
      ],
      "depends_on": []
    },
    {
      "id": "REL.VALIDITY",
      "title": "The marriage or civil partnership is legally valid",
      "plain_english": "The rules ask that the marriage or civil partnership is recognised as valid in the country where it took place.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.2.7",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "marriage_legally_valid",
      "evidence": [],
      "depends_on": [
        "REL.MARRIAGE"
      ]
    },
    {
      "id": "REL.COHABITATION",
      "title": "Unmarried partners living together for two years",
      "plain_english": "Where the couple are not married or in a civil partnership, the rules ask that they have lived together in a relationship akin to marriage or civil partnership for at least two years before the date of application. What matters is coverage across the whole period rather than the number of documents: evidence spread over the two years, addressed to each of you and to you jointly, carries more weight than many documents from one month.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "GEN.1.2(iv)",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "cohabitation_two_years",
      "evidence": [
        {
          "id": "cohabitation-evidence",
          "label": "Documents addressed to you, to your partner, and to you jointly, spread across the whole period — at least one for each quarter",
          "holder": "joint",
          "count": {
            "min": 8,
            "period": "quarter"
          },
          "format_rules": [
            "Spread across the period rather than clustered; a mix of addressees carries more weight than several of the same kind"
          ]
        }
      ],
      "depends_on": [],
      "params": {
        "years_figure": "cohabitation_years_unmarried"
      }
    },
    {
      "id": "REL.AGE",
      "title": "Both parties aged 18 or over",
      "plain_english": "The rules ask that both the applicant and their partner are aged 18 or over at the date of application.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.2.2 (applicant) · E-ECP.2.3 (partner) · E-LTRP.1.4",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "both_over_18",
      "evidence": [],
      "depends_on": [],
      "params": {
        "minimum_age_figure": "minimum_age"
      }
    },
    {
      "id": "REL.PROHIBITED-DEGREES",
      "title": "Not within the prohibited degrees of relationship",
      "plain_english": "The rules ask that the parties are not related to one another within the prohibited degrees of relationship.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.2.4",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "not_within_prohibited_degrees",
      "evidence": [],
      "depends_on": []
    },
    {
      "id": "REL.MET-IN-PERSON",
      "title": "The couple have met in person",
      "plain_english": "The rules ask that the applicant and their partner have met in person.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.2.5",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "met_in_person",
      "evidence": [],
      "depends_on": []
    },
    {
      "id": "REL.PREVIOUS-ENDED",
      "title": "Any previous relationship has permanently broken down",
      "plain_english": "Where either party has been in a previous marriage, civil partnership or durable relationship, the rules ask that it has permanently broken down.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.2.9",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "previous_relationships_ended",
      "evidence": [],
      "depends_on": []
    },
    {
      "id": "FIN.WHOSE-INCOME",
      "title": "Whose income counts at this stage",
      "plain_english": "Which income can be counted differs by stage. The sponsor's income counts at every stage. At entry clearance the applicant is outside the UK and their income cannot be counted; at extension and settlement income from the applicant's permitted employment in the UK can be counted alongside it.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.3.1 · E-LTRP.3.1 — sources of income",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "whose_income_counts",
      "evidence": [],
      "depends_on": [
        "FIN.CATEGORY"
      ]
    },
    {
      "id": "FIN.GROSS-NOT-NET",
      "title": "Income is assessed gross, before tax",
      "plain_english": "The rules assess income before tax and deductions. A net figure understates what counts and is one of the most common reasons a financial requirement is assessed differently than expected.",
      "citation": {
        "instrument": "Appendix FM-SE",
        "paragraph": "gross annual income",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-se-family-members-specified-evidence"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "figures_are_gross",
      "evidence": [],
      "depends_on": [
        "FIN.CATEGORY"
      ]
    },
    {
      "id": "FIN.SAVINGS-SOURCE",
      "title": "Savings are from a lawful source and under their own control",
      "plain_english": "The rules ask that cash savings are held by the applicant, their partner or both jointly, are under their own control, and come from a lawful source.",
      "citation": {
        "instrument": "Appendix FM-SE",
        "paragraph": "cash savings — lawful source and under their control",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-se-family-members-specified-evidence"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": "savings_only_route",
      "evaluate": "savings_lawful_and_controlled",
      "evidence": [
        {
          "id": "savings-source",
          "label": "Evidence of where the savings came from, where they arrived as a lump sum",
          "holder": "either",
          "count": {
            "min": 1
          }
        }
      ],
      "depends_on": []
    },
    {
      "id": "ENG.EC",
      "title": "English language at entry clearance",
      "plain_english": "At entry clearance the rules ask for English at level A1 in speaking and listening, from a test on the Home Office's list, taken with a provider on that list, unless an exemption applies.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.4.1",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC"
      ],
      "applies_when": null,
      "evaluate": "english_at_level",
      "evidence": [
        {
          "id": "english-certificate",
          "label": "The English language test certificate, from a provider on the Home Office's list",
          "holder": "applicant",
          "count": {
            "min": 1
          }
        }
      ],
      "depends_on": [],
      "params": {
        "level_figure": "english_level_ec"
      }
    },
    {
      "id": "ENG.LTR",
      "title": "English language at the first extension",
      "plain_english": "At the first extension the rules ask for English at level A2 in speaking and listening — a higher level than at entry clearance. Meeting A1 at entry clearance does not carry over.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-LTRP.4.1",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "LTR"
      ],
      "applies_when": null,
      "evaluate": "english_at_level",
      "evidence": [
        {
          "id": "english-certificate-a2",
          "label": "The English language test certificate at level A2, from a provider on the Home Office's list",
          "holder": "applicant",
          "count": {
            "min": 1
          }
        }
      ],
      "depends_on": [],
      "params": {
        "level_figure": "english_level_ltr"
      }
    },
    {
      "id": "ENG.ILR.B1",
      "title": "English language at settlement",
      "plain_english": "At settlement the rules ask for English at level B1. For applications made on or after 26 March 2027 the level rises to B2.",
      "citation": {
        "instrument": "Appendix KoLL",
        "paragraph": "Appendix KoLL — English language for settlement",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-koll"
      },
      "effective_from": "2024-04-11",
      "effective_to": "2027-03-25",
      "stages": [
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "english_at_level",
      "evidence": [
        {
          "id": "english-certificate-b1",
          "label": "The English language test certificate at level B1, from a provider on the Home Office's list",
          "holder": "applicant",
          "count": {
            "min": 1
          }
        }
      ],
      "depends_on": [],
      "params": {
        "level_figure": "english_level_ilr"
      }
    },
    {
      "id": "ENG.ILR.B2",
      "title": "English language at settlement, from 26 March 2027",
      "plain_english": "For settlement applications made on or after 26 March 2027 the rules ask for English at level B2.",
      "citation": {
        "instrument": "Appendix KoLL",
        "paragraph": "Appendix KoLL as amended by HC 1691 — level B2 for settlement from 26 March 2027",
        "published": "2026-03-05",
        "url": "https://www.gov.uk/government/collections/immigration-rules-statement-of-changes"
      },
      "effective_from": "2027-03-26",
      "effective_to": null,
      "stages": [
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "english_at_level",
      "evidence": [
        {
          "id": "english-certificate-b2",
          "label": "The English language test certificate at level B2, from a provider on the Home Office's list",
          "holder": "applicant",
          "count": {
            "min": 1
          }
        }
      ],
      "depends_on": [],
      "params": {
        "level_figure": "english_level_ilr_from_2027"
      }
    },
    {
      "id": "ENG.EXEMPT-NATIONALITY",
      "title": "Exemption by nationality",
      "plain_english": "Nationals of certain majority English-speaking countries are exempt from the English language requirement.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.4.2 — exemptions",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "english_exempt_by_nationality",
      "evidence": [],
      "depends_on": []
    },
    {
      "id": "ENG.EXEMPT-OTHER",
      "title": "Exemption by qualification, age or medical grounds",
      "plain_english": "The requirement does not apply where the applicant holds an academic qualification taught in English that the Home Office recognises as equivalent to a UK degree, is aged 65 or over, or has a physical or mental condition that prevents them meeting it.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.4.2 — exemptions",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "english_exempt_other",
      "evidence": [],
      "depends_on": []
    },
    {
      "id": "ACC.ADEQUATE",
      "title": "Adequate accommodation",
      "plain_english": "The rules ask that there will be adequate accommodation for the family, owned or occupied exclusively by them, without overcrowding as defined in the Housing Act. Whether accommodation is adequate is judged by a caseworker against the property and the number of people who will live in it, so it is not something a calculation can answer.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.3.4",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "assessed_by_caseworker",
      "evidence": [
        {
          "id": "accommodation-evidence",
          "label": "Evidence of the accommodation — a tenancy agreement, mortgage statement or land registry entry",
          "holder": "either",
          "count": {
            "min": 1
          }
        }
      ],
      "depends_on": []
    },
    {
      "id": "ACC.NO-PUBLIC-FUNDS",
      "title": "Maintained without recourse to public funds",
      "plain_english": "The rules ask that the applicant and their family can be adequately maintained and accommodated without recourse to public funds.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.3.4",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "without_public_funds",
      "evidence": [],
      "depends_on": []
    },
    {
      "id": "ACC.RIGHT-TO-OCCUPY",
      "title": "A legal right to occupy the accommodation",
      "plain_english": "The rules ask that there is a legal right to occupy the accommodation — as owner, tenant, or with the permission of the person who is.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.3.4",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "legal_right_to_occupy",
      "evidence": [
        {
          "id": "right-to-occupy",
          "label": "A letter from the owner or landlord confirming permission to occupy, where the property is not owned or rented by you",
          "holder": "either",
          "count": {
            "min": 1
          },
          "freshness": {
            "window_days": 28,
            "relative_to": "date_of_application",
            "action_on_stale": "redate"
          }
        }
      ],
      "depends_on": []
    },
    {
      "id": "KOLL.TEST",
      "title": "The Life in the UK test at settlement",
      "plain_english": "At settlement the rules ask for a pass in the Life in the UK test, unless an exemption on age or medical grounds applies.",
      "citation": {
        "instrument": "Appendix KoLL",
        "paragraph": "Appendix KoLL — knowledge of life in the UK",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-koll"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "life_in_uk_test",
      "evidence": [
        {
          "id": "life-in-uk-pass",
          "label": "The Life in the UK test pass notification",
          "holder": "applicant",
          "count": {
            "min": 1
          }
        }
      ],
      "depends_on": []
    },
    {
      "id": "KOLL.INTERACTION",
      "title": "Both limbs are needed at settlement",
      "plain_english": "Knowledge of language and life has two limbs at settlement and both must be met: a pass in the Life in the UK test, and English at the level required for the stage. Passing the test does not remove the language requirement.",
      "citation": {
        "instrument": "Appendix KoLL",
        "paragraph": "Appendix KoLL — both requirements",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-koll"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "koll_interaction",
      "evidence": [],
      "depends_on": [
        "KOLL.TEST"
      ]
    },
    {
      "id": "EVD.PAYSLIP-WINDOW",
      "title": "Payslips and statements dated within the specified window",
      "plain_english": "The rules date payslips and bank statements against the date of application, and that date moves as evidence is gathered. Evidence covering a period ending with the date of application must be dated no earlier than 28 days before it.",
      "citation": {
        "instrument": "Appendix FM-SE",
        "paragraph": "evidence dated no earlier than 28 days before the date of application",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-se-family-members-specified-evidence"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "evidence_specification_only",
      "evidence": [
        {
          "id": "payslips-in-window",
          "label": "Payslips covering the required period, the most recent dated within 28 days of the date of application",
          "holder": "sponsor",
          "count": {
            "min": 6,
            "period": "month"
          },
          "freshness": {
            "window_days": 28,
            "relative_to": "date_of_application",
            "action_on_stale": "recollect"
          }
        }
      ],
      "depends_on": [],
      "params": {
        "window_days_figure": "payslip_window_days"
      }
    },
    {
      "id": "EVD.BANK-FORMAT",
      "title": "Bank statements on stationery or stamped",
      "plain_english": "The rules ask that bank statements are on the bank's own stationery. Electronic statements are accepted where accompanied by a letter from the bank on its letterhead, or stamped on every page.",
      "citation": {
        "instrument": "Appendix FM-SE",
        "paragraph": "bank statements — official stationery, or a supporting letter or stamp",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-se-family-members-specified-evidence"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "evidence_specification_only",
      "evidence": [
        {
          "id": "bank-statements-format",
          "label": "Bank statements for the required period",
          "holder": "either",
          "count": {
            "min": 6,
            "period": "month"
          },
          "format_rules": [
            "On the bank's own stationery",
            "Or electronic statements with a letter from the bank on its letterhead, or a stamp on every page"
          ]
        }
      ],
      "depends_on": []
    },
    {
      "id": "EVD.EMPLOYER-LETTER",
      "title": "The employer letter's required elements",
      "plain_english": "Where an employer letter is relied on, the rules ask that it confirms the person's employment and gross annual salary, the length of employment, the period over which the salary has been paid at that level, and the type of employment. A letter missing an element can be re-issued rather than re-collected.",
      "citation": {
        "instrument": "Appendix FM-SE",
        "paragraph": "employer letter — required contents",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-se-family-members-specified-evidence"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "evidence_specification_only",
      "evidence": [
        {
          "id": "employer-letter-elements",
          "label": "A letter from the employer confirming employment, gross annual salary, length of employment, how long the salary has been paid at that level, and the type of employment",
          "holder": "sponsor",
          "count": {
            "min": 1
          },
          "freshness": {
            "window_days": 28,
            "relative_to": "date_of_application",
            "action_on_stale": "redate"
          }
        }
      ],
      "depends_on": []
    },
    {
      "id": "EVD.DOCUMENT-FORMAT",
      "title": "Documents in the specified format",
      "plain_english": "The rules ask for documents in a specified format: originals rather than copies unless stated otherwise, complete rather than extracts, and with a full certified translation where the document is not in English or Welsh. A document that is present but unusable is a gap, not a tick.",
      "citation": {
        "instrument": "Appendix FM-SE",
        "paragraph": "specified documents — originals, completeness, and certified translation",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-se-family-members-specified-evidence"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "evidence_specification_only",
      "evidence": [
        {
          "id": "translations",
          "label": "A full certified translation for any document not in English or Welsh",
          "holder": "either",
          "count": {
            "min": 1
          },
          "format_rules": [
            "Certified by a qualified translator for applications made inside the UK",
            "Including the translator's contact details, confirmation of accuracy, date and signature"
          ]
        }
      ],
      "depends_on": []
    },
    {
      "id": "SPN.STATUS",
      "title": "The partner's citizenship or immigration status",
      "plain_english": "The rules ask that the applicant's partner is one of the following: a British or Irish citizen; present and settled in the UK; in the UK with protection status; in the UK with limited leave under Appendix EU; in the UK with limited leave as a worker or business person under Appendix ECAA; or in the UK with permission as a stateless person. Where the partner is none of these, this route is not available, whatever the income or savings.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.2.1",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "sponsor_status",
      "evidence": [
        {
          "id": "sponsor-status-evidence",
          "label": "Evidence of your partner's status — a passport, certificate of naturalisation, biometric residence permit, or a share code for their online immigration status",
          "holder": "sponsor",
          "count": {
            "min": 1
          }
        }
      ],
      "depends_on": []
    },
    {
      "id": "REL.GENUINE",
      "title": "The relationship is genuine and subsisting",
      "plain_english": "The rules ask that the relationship between the applicant and their partner is genuine and subsisting. This is judged by a caseworker on the evidence of the relationship as a whole, so it is not something a calculation can answer. What helps is evidence across the length of the relationship: time spent together, communication, shared finances or responsibilities, and the knowledge each has of the other's life.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.2.6",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "assessed_by_caseworker",
      "evidence": [
        {
          "id": "relationship-evidence",
          "label": "Evidence of the relationship over its whole length — photographs together, messages and call records, travel and visits, and anything held or paid for jointly",
          "holder": "joint",
          "count": {
            "min": 1
          },
          "format_rules": [
            "Spread across the relationship rather than one period",
            "Evidence from third parties carries more weight than your own account"
          ]
        }
      ],
      "depends_on": []
    },
    {
      "id": "REL.INTENTION",
      "title": "Intention to live together permanently in the UK",
      "plain_english": "The rules ask that the applicant and their partner intend to live together permanently in the UK. This is judged by a caseworker on the evidence, so it is not something a calculation can answer. What speaks to it is practical: where you will live, arrangements already made, and the plans each of you has described.",
      "citation": {
        "instrument": "Appendix FM",
        "paragraph": "E-ECP.2.10",
        "published": "2024-04-11",
        "url": "https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-fm-family-members"
      },
      "effective_from": "2024-04-11",
      "effective_to": null,
      "stages": [
        "EC",
        "LTR",
        "ILR"
      ],
      "applies_when": null,
      "evaluate": "assessed_by_caseworker",
      "evidence": [
        {
          "id": "intention-evidence",
          "label": "Evidence of your plans to live together in the UK — the address, any tenancy or ownership, and arrangements made for the move",
          "holder": "joint",
          "count": {
            "min": 1
          }
        }
      ],
      "depends_on": []
    }
  ],
  "out_of_scope": {
    "dependent_children": {
      "reason": "This application would include dependent children, which Verity does not cover.",
      "referral_hint": "A regulated immigration adviser can take this on. GOV.UK lists registered advisers at https://www.gov.uk/find-an-immigration-adviser."
    },
    "self_employed_income": {
      "reason": "The financial requirement would rely on self-employment income, which Verity does not cover.",
      "referral_hint": "A regulated immigration adviser can assess self-employment evidence. GOV.UK lists registered advisers at https://www.gov.uk/find-an-immigration-adviser."
    },
    "previous_refusal": {
      "reason": "A previous refusal changes how an application needs to be prepared, and Verity does not cover it.",
      "referral_hint": "A regulated immigration adviser can review the refusal and what follows from it. GOV.UK lists registered advisers at https://www.gov.uk/find-an-immigration-adviser."
    },
    "overstay": {
      "reason": "A period of overstaying changes how an application needs to be prepared, and Verity does not cover it.",
      "referral_hint": "A regulated immigration adviser can assess the immigration history. GOV.UK lists registered advisers at https://www.gov.uk/find-an-immigration-adviser."
    },
    "criminal_record": {
      "reason": "A criminal record engages the suitability rules, which Verity does not cover.",
      "referral_hint": "A regulated immigration adviser can assess how the suitability rules apply. GOV.UK lists registered advisers at https://www.gov.uk/find-an-immigration-adviser."
    },
    "ten_year_route": {
      "reason": "The ten-year route is assessed differently, and Verity does not cover it.",
      "referral_hint": "A regulated immigration adviser can assess the ten-year route. GOV.UK lists registered advisers at https://www.gov.uk/find-an-immigration-adviser."
    },
    "other_income_route": {
      "reason": "Income routes other than salaried employment and cash savings — self-employment, dividends, pensions, rental or investment income — are outside what Verity covers.",
      "referral_hint": "A regulated immigration adviser can assess these income sources. GOV.UK lists registered advisers at https://www.gov.uk/find-an-immigration-adviser."
    },
    "sponsor_not_eligible_to_sponsor": {
      "reason": "On the answer given, your partner does not hold one of the statuses this route requires, so a partner visa on the five-year route is not available to you — regardless of income or savings.",
      "referral_hint": "There may be another route, and a regulated immigration adviser can tell you which. GOV.UK lists registered advisers at https://www.gov.uk/find-an-immigration-adviser."
    },
    "adequate_maintenance_route": {
      "reason": "Because your partner receives one of the disability or carer's benefits listed in the rules, the £29,000 minimum income requirement does not apply to your application at all. A different test applies instead — adequate maintenance — which Verity does not cover.",
      "referral_hint": "This is usually better news than the income threshold, and a regulated immigration adviser can work through the adequate maintenance test with you. GOV.UK lists registered advisers at https://www.gov.uk/find-an-immigration-adviser."
    },
    "fiance_or_proposed_civil_partner": {
      "reason": "A fiancé(e) or proposed civil partner application is a different route, with its own requirements, and Verity does not cover it.",
      "referral_hint": "A regulated immigration adviser can advise on the fiancé(e) route. GOV.UK lists registered advisers at https://www.gov.uk/find-an-immigration-adviser."
    }
  }
}